import { userSettings } from "@/globals/userSettings";
import { t } from "@/i18n/translate";
import { speak, stopSpeaking } from "@/utils/speech";

export default function toggleScreenReader(enable = false) {
  if (!('speechSynthesis' in window)) {
    if (enable) alert(t("Sorry, your browser does not support the Screen Reader feature (Speech Synthesis)."));
    return;
  }

  if (enable) {
    speak(t("Sienna Screen Reader Enabled"));
  } else {
    stopSpeaking();
    speak(t("Sienna Screen Reader Disabled"));
  }
}